export const K_FACTOR   = 32;
export const COMMISSION = 0.20; // 20% удержание платформы

export const DEFAULT_RATING = 500;

export function calculateExpectedScore(
  ratingA: number,
  ratingB: number
): number {
  return 1 / (1 + Math.pow(10, (ratingB - ratingA) / 400));
}

export interface EloResult {
  winnerDelta: number;
  loserDelta: number;
  winnerNewRating: number;
  loserNewRating: number;
}

export function calculateElo(
  winnerRating: number,
  loserRating: number,
  isGammon: boolean,
  isBackgammon: boolean
): EloResult {
  const expected = calculateExpectedScore(winnerRating, loserRating);

  // Gammon/backgammon count as double/triple
  let multiplier = 1;
  if (isBackgammon) multiplier = 3;
  else if (isGammon) multiplier = 2;

  const k = K_FACTOR * multiplier;
  const delta = Math.round(k * (1 - expected));

  return {
    winnerDelta: delta,
    loserDelta: -delta,
    winnerNewRating: winnerRating + delta,
    loserNewRating: Math.max(100, loserRating - delta),
  };
}

export interface GameRewards {
  /** Монеты. Положительные = начислить, отрицательные = снять */
  coinsGained: number;
  expGained: number;
}

/**
 * Расчёт награды победителя.
 * При наличии ставки:
 *   банк = betAmount × 2
 *   победитель получает: банк × (1 − COMMISSION)
 *   (т.е. свои деньги назад + деньги соперника минус комиссия)
 */
export function calculateWinnerRewards(
  isGammon: boolean,
  isBackgammon: boolean,
  isMatchWin: boolean,
  betAmount: number,
  winStreak: number = 0
): GameRewards {
  // Монеты ТОЛЬКО от ставок — бесплатно не раздаём (монеты выводятся = реальные деньги)
  const betPayout = betAmount > 0
    ? Math.floor(betAmount * 2 * (1 - COMMISSION))
    : 0;

  // Опыт: бесплатно, не выводится
  let baseExp = 50;
  if (isBackgammon)    baseExp = 150;
  else if (isGammon)   baseExp = 100;
  if (isMatchWin)      baseExp = Math.floor(baseExp * 1.5);

  // Серия побед: +10% опыта за каждую подряд, максимум ×2
  if (winStreak > 1) {
    const streakMult = Math.min(1 + (winStreak - 1) * 0.1, 2.0);
    baseExp = Math.floor(baseExp * streakMult);
  }

  return {
    expGained:   baseExp,
    coinsGained: betPayout,
  };
}

/**
 * Расчёт потерь проигравшего.
 */
export function calculateLoserRewards(betAmount: number): GameRewards {
  return {
    expGained:   15,
    coinsGained: betAmount > 0 ? -betAmount : 0,
  };
}
